import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "statistics-home2",
  templateUrl: "./statistics-home2.component.html",
  styleUrls: ["./statistics-home2.component.scss"],
})
export class StatisticsHome2Component implements OnInit {
  statistics = [
    {
      photo: "../../../assets/images/mod1-img1-ar2.png",
      title: "Make yourself a famous brand",
    },
    {
      photo: "../../../assets/images/mod1-img2.png",
      title: "Easily reach your customer",
    },
    {
      photo: "../../../assets/images/mod1-img3-ar.png",
      title: "Increase your sales",
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
